import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { analyticsConfigured, getStoredConsent, setConsent } from "@/lib/analytics";

/**
 * Minimal Consent Mode v2 banner: analytics/ad storage stays denied until the
 * visitor accepts. Rendered only after mount so prerendered HTML stays clean.
 */
const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (analyticsConfigured && getStoredConsent() === null) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const choose = (granted: boolean) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-50 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80"
    >
      <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-3">
        <p className="text-sm text-muted-foreground flex-1">
          We use cookies for anonymous analytics to improve this free calculator.
          No personal data is sold. You can decline and the site works exactly the same.
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={() => choose(false)}>
            Decline
          </Button>
          <Button size="sm" onClick={() => choose(true)}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
